<template>
  <div class="service-detail-page">
    <nav-bar/>
    <search-bar/>
    <div class="main" v-if="loading">
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
              :to="{ path: '/me/salesservice' }"
              v-if="$route.query.type != 'finance'"
          >服务订单
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/me/finance' }" v-else>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-card shadow="hover" class="mb20">
        <p slot="header">客户信息</p>
        <el-table :data="[service_detail]" style="width: 100%" border>
          <el-table-column prop="company_name" label="企业名称" align="center"></el-table-column>
          <el-table-column prop="member_nick_name" label="发布人" align="center"></el-table-column>
          <el-table-column prop="member_account" label="联系电话" align="center"></el-table-column>
          <el-table-column prop="create_time" label="发布时间" align="center"></el-table-column>
        </el-table>
      </el-card>
      <el-card v-if="service_detail.platform_sale_check_state === '0'" shadow="hover" class="mb20">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">服务信息</span>
        </div>
        <el-form style="width: 500px;" label-width="100px">
          <el-form-item label="服务类型">
            <el-select v-model="form_data.type_id" placeholder="请选择" size="small">
              <el-option
                  v-for="item in types"
                  :key="item.type_id"
                  :label="item.type_name"
                  :value="item.type_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务工程师">
            <el-select v-model="form_data.level_id" placeholder="请选择" size="small">
              <el-option
                  v-for="item in levels"
                  :key="item.level_id"
                  :label="item.level_name"
                  :value="item.level_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务时间">
            <el-date-picker
                size="small"
                v-model="form_data.service_time"
                type="daterange"
                value-format="yyyy-MM-dd hh:mm:ss"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="服务地址">
            <el-select v-model="form_data.address_id"
                       :placeholder="is_Empty(form_data.address_id)?address_content:'请选择'" size="small">
              <el-option
                  v-for="item in company_address_list"
                  :key="item.address_id"
                  :label="item.address_content"
                  :value="item.address_id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发票信息">
            <el-select v-model="form_data.invoice_id" placeholder="请选择" size="small">
              <el-option
                  v-for="item in company_invoice_list"
                  :key="item.invoice_id"
                  :label="item.invoice_content"
                  :value="item.invoice_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input v-model="form_data.order_remark" disabled type="textarea" :rows="5" resize="none"/>
          </el-form-item>
          <el-form-item label="备注图片">
            <img-upload
                :file_list.sync="service_detail.order_imgs"
                :disabled="true"
            />
          </el-form-item>

          <el-form-item label="服务内容">
            <el-input v-model="service_detail.service_content" placeholder="请输入服务内容" type="textarea" :rows="5"
                      resize="none"/>
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 服务信息 审核通过后显示 -->
      <el-card shadow="hover" class="mb20" v-if="is_disabled">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">服务信息</span>
        </div>
        <el-table :data="[service_detail]" style="width: 100%" border>
          <el-table-column prop="order_no" label="订单编号" align="center"></el-table-column>
          <el-table-column prop="type_name" label="服务类型" align="center"></el-table-column>
          <el-table-column prop="level_name" label="服务人员" align="center"></el-table-column>
          <el-table-column label="服务时间" align="center">
            <template slot-scope="scope">
            <span>{{
                formatDate(scope.row.service_start_time, 'yyyy-MM-dd')
              }}~{{ formatDate(scope.row.service_end_time, 'yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_distance" label="距离（km）" align="center"></el-table-column>
          <el-table-column
              prop="order_actual_price"
              label="价格"
              align="center"
              v-if="service_detail.platform_sale_check_state == '1'"
          ></el-table-column>
        </el-table>
      </el-card>
      <!-- 合同信息 审核通过后显示-->
      <el-card shadow="hover" class="mb20" v-if="!is_Empty(service_detail.company_contract)">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">合同信息</span>
        </div>
        <img-upload
            :file_list.sync="service_detail.company_contract"
            :disabled="true"
        />
      </el-card>
      <!-- 服务描述 审核通过后显示-->
      <el-card shadow="hover" class="mb20" v-if="!is_Empty(service_detail.company_contract)">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">客户描述</span>
        </div>
        <el-input
            type="textarea"
            class="mb20"
            :rows="10"
            :value="service_detail.order_remark"
            resize="none"
            :disabled="true"
        ></el-input>
        <div>

          <img-upload
              :file_list.sync="service_detail.order_imgs"
              :disabled="true"
          />
        </div>
        <div>
          <div class="before-title black mb20 mt20">服务内容</div>
          <el-input
              type="textarea"
              class="mb20"
              :rows="10"
              :value="service_detail.service_content"
              resize="none"
              :disabled="true"
          ></el-input>
        </div>
      </el-card>

      <!-- 评价信息 审核通过后并且未评价确认显示-->
      <el-card shadow="hover" class="mb20" v-if="assessment_list.length">
        <div slot="header" class="fr ac jsb">
          <span class="before-title">评价信息</span>
        </div>
        <el-table :data="assessment_list" style="width: 100%" border>
          <el-table-column label="头像" align="center" width="100">
            <template slot-scope="scope">
              <el-avatar :size="60" :src="scope.row.member_img">
                <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
              </el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="member_nick_name" label="姓名" align="center" width="100"></el-table-column>
          <el-table-column prop="create_time" label="评价时间" align="center" width="180"></el-table-column>
          <el-table-column label="评分" align="center" width="120">
            <template slot-scope="scope">
              <el-rate :value="scope.row.assessment_star * 1 || 0" disabled></el-rate>
            </template>
          </el-table-column>
          <el-table-column label="评价内容" align="center">
            <template slot-scope="scope">
              {{ scope.row.assessment_desc ? scope.row.assessment_desc : "此用户没有填写评价!" }}
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              width="120"
              align="center"
          >
            <template slot-scope="scope" v-if="scope.row.platform_sale_check_state === '0'">
              <el-button type="text" @click="platformSaleAssessmentRefuse(scope.row.assessment_id)">取消</el-button>
              <el-button type="text" @click="platformSaleAssessmentAccept(scope.row.assessment_id)">确认</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div class="info-box" v-if="false">
        <!-- 订单信息 -->
        <div class="service-cell fr afs mb20">
          <p class="fz16 service-cell-title">订单信息:</p>
          <div class="pay-table">
            <div class="tr fr">
              <div class="th fg fs">服务类型</div>
              <div class="th fg fs">服务工程师</div>
              <div class="th fg fs">服务距离</div>
              <div class="th fg fs">服务时间</div>
              <div class="th fg fs">价格</div>
            </div>
            <div class="tr fr">
              <div class="td fg fs">
                <span>{{ service_detail.type_name }}</span>
              </div>
              <div class="td fg fs">
                <span>{{ service_detail.level_name }}</span>
              </div>
              <div class="td fg fs fr ac jc">
                <span>{{ service_detail.order_distance }}km</span>
              </div>

              <div class="td fg fs fr ac jc">
                <span>{{
                    formatDate(service_detail.service_start_time, 'yyyy-MM-dd')
                  }}~{{ formatDate(service_detail.service_end_time, 'yyyy-MM-dd') }}</span>
              </div>
              <div class="td fg fs">
                <span>￥{{ service_detail.order_actual_price }}</span>
              </div>
            </div>
            <div class="tr fr ac jfe">
              <div class="td">
                <span>合计：</span>
                <span class="red">￥{{ order_actual_price }}</span>
                <i
                    v-show="service_detail.platform_sale_check_state == '0'"
                    class="el-icon-edit blue cursor"
                    @click="editPrice"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div class="service-cell fr afs mb20">
          <p class="fz16 service-cell-title">问题描述:</p>
          <div class="ml20">
            <el-input
                type="textarea"
                resize="none"
                :value="service_detail.order_remark"
                disabled
            ></el-input>
          </div>
        </div>
        <div class="service-cell fr afs mb20" v-if="service_detail.order_imgs.length">
          <p class="fz16 service-cell-title">图片描述:</p>
          <div class="ml20 fr">
            <el-image
                :src="i"
                v-for="(i,k) in service_detail.order_imgs"
                :key="k"
                class="img"
                :preview-src-list="service_detail.order_imgs"
            />
          </div>
        </div>

        <div class="mt20 fr ac jc">
          <template v-if="service_detail.platform_sale_check_state == '0'">
            <el-button size="medium" type="primary" @click="memberConfirmOrder">确认订单</el-button>
            <el-button size="medium" @click="cancelOrder">驳回订单</el-button>
          </template>
        </div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  data() {
    return {
      service_detail: {},
      loading: false,
      order_actual_price: "",
      assessment_list: [],
      types: [],//服务类型
      levels: [],//服务人员等级列表
      company_address_list: [],//客户地址列表
      company_invoice_list: [],//客户地址列表
      form_data: {
        type_name: "",
        type_id: "",
        level_name: "",
        level_id: "",
        service_time: [],
        service_content: "",
        company_province: "",
        company_city: "",
        company_country: "",
        company_detailed: "",
        company_contract: [],
        invoice_id: null,
        address_id: null
      },
      address_content: ""
    };
  },
  computed: {
    is_disabled() {
      if (this.is_Empty(this.service_detail)) return true;
      return Number(this.service_detail.company_check_state) !== 1 ||
          Number(this.service_detail.platform_sale_check_state) !== 0;
    }
  },
  created() {
    this.getServiceOrderDetail();
  },
  watch: {},
  methods: {
    // 修改价格
    editPrice() {
      this.$prompt("请修改服务价格", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]+([.]{1}[0-9]+){0,1}$/,
        inputErrorMessage: "格式不正确"
      })
          .then(({value}) => {
            this.order_actual_price = value;
          })
          .catch(() => {
          });
    },
    // 驳回订单
    cancelOrder(id) {
      this.$confirm("是否驳回该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("serviceInterfaces/v1.0/sellRejectOrder", {
              order_id: id
            }).then(res => {
              this.$message({
                type: "success",
                message: "已取消!"
              });
              this.getSellOrders();
            });
          })
          .catch(() => {
          });
    },
    // 确认订单
    memberConfirmOrder() {
      let obj = {};
      obj.order_id = this.$route.query.id;
      obj.is_summit = 1;
      if (
          this.order_actual_price != this.service_detail.order_actual_price
      ) {
        obj.order_actual_price = this.order_actual_price;
      }
      this.post(
          "serviceInterfaces/v1.0/sellConfirmServiceOrder",
          obj
      ).then(res => {
        this.$message({
          message: "已审核通过订单",
          type: "success"
        });
        this.getServiceOrderDetail();
      });
    },
    // 获取服务类型
    getServiceTypes() {
      this.post("serviceInterfaces/v1.0/getServiceTypes", {}).then((res) => {
        this.types = res.data;
      });
    },
    // 获取服务人员级别
    getServiceLevels() {
      this.post("serviceInterfaces/v1.0/getServiceLevels", {}).then((res) => {
        this.levels = res.data;
      });
    },
    //获取客户地址列表
    platformSaleGetCompanyAddressList() {
      this.post("addressInterfaces/v1.0/platformSaleGetCompanyAddressList",
          {
            company_id: this.service_detail.company_id,
            page: -1,
            pageSize: -1
          })
          .then(res => {
            let arr = res.data;
            arr.forEach(el => {
              el.address_content = `${el.address_province}${el.address_city === el.address_province ? "" : el.address_city === "市辖区" ? "" : el.address_city}${el.address_country}  ${el.address_detailed}`
            })
            this.company_address_list = res.data;
          })
    },
    platformSaleGetInvoiceList() {
      this.post("invoiceInterfaces/v1.0/platformSaleGetInvoiceList",
          {
            company_id: this.service_detail.company_id,
            page: -1,
            pageSize: -1
          })
          .then(res => {
            let arr = res.data;
            arr.forEach(el => {
              el.invoice_content = `${el.invoice_name} ${el.invoice_taxno}`
            })
            this.company_invoice_list = res.data;
          })
    },
    // 订单详情
    getServiceOrderDetail() {
      this.post("serviceInterfaces/v1.0/getServiceOrderDetail", {
        order_id: this.$route.query.id
      }).then(res => {
        let obj = res.data;
        let form_data = {};
        if (obj.platform_sale_check_state === '0') {
          form_data = {
            type_name: obj.type_name,
            type_id: Number(obj.type_id),
            level_name: obj.level_name,
            level_id: Number(obj.level_id),
            service_time: [],
            service_content: obj.service_content,
            company_province: obj.company_province,
            company_city: obj.company_city,
            company_country: obj.company_country,
            company_detailed: obj.company_detailed,
            company_contract: [],
            invoice_id: this.is_Empty(obj.invoice_id) ? null : Number(obj.invoice_id),
          }
          this.address_content = `${obj.company_province}${obj.company_city === obj.company_province ? "" : obj.company_city === "市辖区" ? "" : obj.company_city}${obj.company_country}  ${obj.company_address}`
          if (!this.is_Empty(obj.service_time)) {
            form_data.service_time = [order.service_time, order.service_time];
          } else {
            form_data.service_time = [obj.service_start_time, obj.service_end_time]
          }
        } else {
          obj.company_contract = this.strToArr(obj.company_contract);
        }
        obj.order_imgs = this.strToArr(obj.order_imgs);
        this.form_data = form_data;
        this.service_detail = obj;
        this.order_actual_price = obj.order_actual_price;
        this.loading = true;
        if (!this.is_disabled) {
          this.getServiceTypes();
          this.getServiceLevels();
          this.platformSaleGetCompanyAddressList();
          this.platformSaleGetInvoiceList();
        } else {
          this.getServiceOrderAssessmentList();
        }
      });
    },
    //获取订单评价内容
    getServiceOrderAssessmentList() {
      this.post("serviceInterfaces/v1.0/getServiceOrderAssessmentList", {
        order_id: this.$route.query.id,
        platform_sale_check_state: 0
      }).then(res => {
        this.assessment_list = res.data;
      })
    },
    //取消评价信息
    platformSaleAssessmentRefuse(assessment_id) {
      this.$confirm('是否取消该评价内容?', '温馨提示').then(() => {
        this.post("serviceInterfaces/v1.0/platformSaleAssessmentRefuse", {assessment_id}).then(res => {
          this.$message.success("已取消!");
          this.getServiceOrderAssessmentList();
        })
      })
    },
    //确认评价
    platformSaleAssessmentAccept(assessment_id) {
      this.$confirm('是否确认该评价内容为客户评价?', '温馨提示').then(() => {
        this.post("serviceInterfaces/v1.0/platformSaleAssessmentAccept", {assessment_id}).then(res => {
          this.$message.success("已确认!");
          this.getServiceOrderAssessmentList();
        })
      })
    }
  },
  components: {NavBar, SearchBar, FooterBar}
};
</script>

<style scoped lang="scss">
.service-detail-page {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .info-box {
      background-color: #fff;
      padding: 20px;
      font-size: 14px;

      .service-cell {
        .service-cell-title {
          width: 130px;
          text-align: right;
        }

        .pay-table {
          width: calc(100% - 170px);
          margin-left: 20px;
          border: 1px solid #e5e5e5;;
          border-bottom: none;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            .th {
              height: 50px;
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              width: 20%;
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;

              &:last-child {
                border-right: none;
              }
            }

            &:last-child .td {
              border-bottom: none;
            }
          }
        }

        .img {
          width: 100px;
          height: 100px;
          margin-right: 20px;
        }
      }

      .receipt {
        width: 40%;
        border: 1px solid #e5e5e5;

        .top {
          padding: 20px;
          border-bottom: 1px solid #e5e5e5;
        }

        .bottom {
          padding: 30px 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/salesservice/servicedetail.vue